// 角色 接口管理
import request from '../request.js'

// 获取菜单信息
export const selectAll = function (data) {
    return request({
        url: 'sysRole/selectAll',
        method: 'post',
        data
    })
}

// 获取角色列表
export const selectTree = function (data) {
    return request({
        url: 'sysRole/selectTree',
        method: 'post',
        data
    })
}

// 保存更新角色
export const saveOrUpdate = function (data) {
    return request({
        url: 'sysRole/saveOrUpdate',
        method: 'post',
        data
    })
}

// 获取角色信息
export const getInfoById = function (data) {
    return request({
        url: 'sysRole/getInfoById',
        method: 'post',
        data
    })
}

// 删除角色
export const deleteById = function (data) {
    return request({
        url: 'sysRole/deleteById',
        method: 'post',
        data
    })
}

// 获取角色tree数据-李开明
export const selectRoleTree = function (data) {
    return request({
        url: 'sysRole/selectRoleTree',
        method: 'post',
        data
    })
}
//保存/更新角色菜单按钮-李开明
export const saveOrUpdateRoleMenuBtn = function (data) {
    return request({
        url: 'sysRoleMenuBtn/saveOrUpdate',
        method: 'post',
        data
    })
}
//保存/更新角色菜单-李开明
export const saveOrUpdateRoleMenu = function (data) {
    return request({
        url: 'sysRoleMenu/saveOrUpdate',
        method: 'post',
        data
    })
}

// 根据角色id，获取角色菜单信息-李开明
export const getRoleMenuByRoleId = function (data) {
    return request({
        url: 'sysRoleMenu/getRoleMenuByRoleId',
        method: 'post',
        data
    })
}
